import React from "react";
import { LoginSocialGoogle } from "reactjs-social-login";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectGoogleProfileData,
  setGoogleAdsLoggedInUserInfo,
  SelectGoogleAccessToken,
} from "./GoogleAdsSlice";

const REDIRECT_URI = "http://localhost:3000/funnel-leakage";
// const REDIRECT_URI = "https://dashboard.causalfunnels.com/funnel-leakage";
const SCOPE = "https://www.googleapis.com/auth/adwords";

const GoogleAuth = () => {
  const dispatch = useDispatch();
  // console.log(useSelector(state => state.google_ads))
  const googleAdsLoggedInUserInfo = useSelector(SelectGoogleProfileData);
  const googleAdsAccessToken = useSelector(SelectGoogleAccessToken);
  // console.log("googleAdsLoggedInUserInfo", googleAdsLoggedInUserInfo);
  // console.log("googleAdsAccessToken", googleAdsAccessToken);


  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 border-b-2 py-3">
      <h3 className="text-lg font-semibold">Google ads data</h3>
      <LoginSocialGoogle
        client_id={
          process.env.REACT_APP_GOOGLE_CLIENT_ID ||
          "266936436921-914lago3v2b2utuo6b57r1unlra7p4hn.apps.googleusercontent.com"
        }
        scope={SCOPE}
        onLogoutSuccess={() => console.log("CF -- Goolge Logout")}
        redirect_uri={REDIRECT_URI}
        onResolve={({ provider, data }) => {
          console.log("Google Auth Data:- ", data);
          dispatch(setGoogleAdsLoggedInUserInfo(data));
        }}
        onReject={(err) => {
          console.log("CF -- Goolge Auth error:- ", err);
        }}
      >
        <button className="cursor-not-allowed bg-indigo-500 hover:bg-indigo-600 text-white py-1.5 px-4 rounded-md w-max">
          Login to view
        </button>
      </LoginSocialGoogle>
    </div>
  );
};

export default GoogleAuth;
